import { Component, OnInit } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import {
  TuiAlertService,
  TuiButtonModule,
  TuiDialogService,
  TuiLoaderModule,
  TuiSvgModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/core';
import {
  TUI_PROMPT,
  TuiDataListWrapperModule,
  TuiInputDateRangeModule,
  TuiInputModule,
  TuiInputNumberModule,
  TuiPaginationModule,
  TuiPromptData,
  TuiSelectModule,
} from '@taiga-ui/kit';
import { TuiTableModule } from '@taiga-ui/addon-table';
import { PageSize } from '../../core/dto/page.size';
import { Router } from '@angular/router';
import { MemberService } from '../../core/services/member.service';
import { Pagination } from '../../core/dto/pagination';
import { FormsModule } from '@angular/forms';
import { TuiValueChangesModule } from '@taiga-ui/cdk';
import { AttendanceService } from '../../core/services/attendance.service';
import { TuiExpandModule } from '@taiga-ui/core';
import { StatusBadgeComponent } from '../../core/dto/status-badge.component';

@Component({
  selector: 'app-attendance',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    TuiButtonModule,
    TuiDataListWrapperModule,
    TuiInputModule,
    TuiExpandModule,
    TuiInputNumberModule,
    TuiLoaderModule,
    TuiPaginationModule,
    TuiSelectModule,
    TuiSvgModule,
    TuiTableModule,
    TuiTextfieldControllerModule,
    FormsModule,
    TuiValueChangesModule,
    TuiInputDateRangeModule,
    StatusBadgeComponent,
  ],
  providers: [AttendanceService],
  templateUrl: './attendance.component.html',
  styleUrl: './attendance.component.scss',
})
export class AttendanceComponent implements OnInit {
  pageSize = new PageSize();
  searchText: any;
  dateFilter: any;
  attendanceData: any[] = [];
  attendanceRows: any[] = [];
  isLoading = false;
  showSearch = false;
  sort = -1;
  userStatus = 'Active';
  tempStatus = true;
  statusMsg = false;
  tempSearchText = '';
  expanded: boolean[] = [];
  memberSessionByMembershipId: Record<string, string> = {};

  constructor(
    private router: Router,
    private attendanceService: AttendanceService,
    private memberService: MemberService
  ) {}

  ngOnInit(): void {
    // this.loadMemberSessions();
    this.getPaginatedAttendance();
  }

  getPaginatedAttendance(): void {
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      filters: {
        sortFilter: this.sort,
        searchValue: this.searchText,
        dateFilter: this.dateFilter,
      },
    });
    this.isLoading = true;
    this.attendanceService
      .getPagedAttendance(payload)
      .then((res) => {
        this.attendanceData = res.data;
        console.log(this.attendanceData);
        this.attendanceRows = [];
        this.attendanceData.forEach((group: any) => {
          const dateLabel = group?._id;
          (group?.data || []).forEach((item: any) => {
            const member = Array.isArray(item?.member)
              ? item.member[0]
              : item?.member || {};
            const sessionValue = this.extractSession(item, group, member);
            const fallbackSession =
              this.memberSessionByMembershipId[member?.membershipId || ''];
            this.attendanceRows.push({
              date: dateLabel,
              session:
                sessionValue && sessionValue !== '-'
                  ? sessionValue
                  : fallbackSession || '-',
              memberId: member?.membershipId || '-',
              firstname: member?.firstname || '-',
              lastname: member?.lastname || '-',
              status: item?.payment?.status || '-',
              createdAt: item?.createdAt || null,
            });
          });
        });
        this.expanded = [];
        this.attendanceData.forEach(() => this.expanded.push(false));
        this.isLoading = false;
        this.pageSize.length = res.totalPages;
      })
      .catch((error) => {
        this.isLoading = false;
      });
  }

  // private loadMemberSessions(): void {
  //   this.memberService
  //     .getAllMembers()
  //     .then((members) => {
  //       const map: Record<string, string> = {};
  //       (members || []).forEach((m: any) => {
  //         const session = Array.isArray(m?.session)
  //           ? m.session[0] || ''
  //           : m?.session || '';
  //         if (m?.membershipId && session) {
  //           map[m.membershipId] = session;
  //         }
  //       });
  //       this.memberSessionByMembershipId = map;
  //     })
  //     .catch(() => {
  //       this.memberSessionByMembershipId = {};
  //     });
  // }

  private extractSession(item: any, group: any, member: any): string {
    const normalize = (value: any): string | undefined => {
      if (Array.isArray(value)) {
        return value[0];
      }
      return value;
    };

    const direct =
      normalize(item?.session) ||
      normalize(item?.sessionType) ||
      normalize(item?.session_type) ||
      normalize(item?.type) ||
      normalize(item?.data?.session) ||
      normalize(item?.attendance?.session) ||
      normalize(item?.attendance?.[0]?.session) ||
      normalize(group?.session) ||
      normalize(group?.sessionType) ||
      normalize(group?.session_type) ||
      normalize(group?.type) ||
      normalize(group?.data?.session) ||
      normalize(member?.session) ||
      normalize(member?.sessionType);

    if (direct) {
      return direct;
    }

    const deepFromItem = this.findSessionValueDeep(item, normalize);
    if (deepFromItem) {
      return deepFromItem;
    }
    const deepFromGroup = this.findSessionValueDeep(group, normalize);
    if (deepFromGroup) {
      return deepFromGroup;
    }
    const deepFromMember = this.findSessionValueDeep(member, normalize);
    if (deepFromMember) {
      return deepFromMember;
    }

    return '-';
  }

  private findSessionValueDeep(
    source: any,
    normalize: (v: any) => string | undefined
  ): string | undefined {
    const visited = new Set<any>();
    const stack: any[] = [];
    if (source && typeof source === 'object') {
      stack.push(source);
    }
    while (stack.length > 0) {
      const current = stack.pop();
      if (!current || typeof current !== 'object') {
        continue;
      }
      if (visited.has(current)) {
        continue;
      }
      visited.add(current);

      if (Array.isArray(current)) {
        for (const element of current) {
          if (element && typeof element === 'object') {
            stack.push(element);
          }
        }
        continue;
      }

      for (const key of Object.keys(current)) {
        const value = (current as any)[key];
        if (/session/i.test(key)) {
          const normalized = normalize(value);
          if (typeof normalized === 'string' && normalized.trim().length > 0) {
            return normalized;
          }
        }
        if (value && typeof value === 'object') {
          stack.push(value);
        }
      }
    }
    return undefined;
  }

  showText(): string {
    let text = '';
    if (this.statusMsg && this.tempSearchText) {
      text += `Showing Results for "${this.tempSearchText}"`;
    }
    return text;
  }

  toggleSort(): void {
    if (this.sort === -1) {
      this.sort = 1;
    } else {
      this.sort = -1;
    }
    this.getPaginatedAttendance();
  }

  toggle(): void {
    this.showSearch = !this.showSearch;
  }

  toggleDropDown(index: any): void {
    this.expanded[index] = !this.expanded[index];
  }

  resetStatus(): void {
    this.searchText = '';
    this.dateFilter = null;
    this.tempSearchText = '';
    this.statusMsg = false;
    this.getPaginatedAttendance();
  }

  search(): void {
    this.statusMsg = true;
    this.tempSearchText = this.searchText;
    this.getPaginatedAttendance();
  }

  cancelSearch(event: Event): void {
    if (!event) {
      this.searchText = null;
      this.getPaginatedAttendance();
    }
  }

  goToPage(event: any): void {
    this.pageSize.pageIndex = event + 1;
    this.getPaginatedAttendance();
  }

  navigateToAdd(): void {
    this.router.navigate(['admin/attendance/add-edit']);
  }

  formatDate(dateString: any) {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  }
}
